<template>
  <div>
    <template v-if="loading">
      <place-full-loading />
    </template>
    <template v-else>
      <div v-if="!place.isGooglePlace && !place.isEkispertPlace && !place.isGeocode && placeFull.images && placeFull.images.length > 0" class="text-center">
        <progressive-img :src="placeFull.images[imageIndex].url" class="w-full" />
        <div v-if="placeFull.images[imageIndex].label" class="text-right text-xs text-gray-400">
          {{ placeFull.images[imageIndex].label }}
        </div>        
        <div v-if="placeFull.images.length > 1">
          <span><a @click="prevImage" class="text-gray-600 text-sm" :class="imageIndex > 0 ? 'visible' : 'invisible'">＜ 前の画像</a></span>
          ({{ imageIndex + 1 }}/{{ placeFull.images.length }})
          <span><a @click="nextImage" class="text-gray-600 text-sm" :class="imageIndex < placeFull.images.length - 1 ? 'visible' : 'invisible'">次の画像 ＞</a></span>
        </div>
      </div>
      <template v-if="getGenreType(genreId) == 'cycle'">
        <place-cycle :place="placeFull" @onRingoPass="onRingoPass" />
      </template>
      <template v-else-if="getGenreType(genreId) == 'locker'">
        <place-tolocca :place="placeFull" />
      </template>
      <template v-else-if="getGenreType(genreId) == 'demand'">
        <place-busstop :place="placeFull" />
      </template>
      <template v-else-if="getGenreType(genreId) == 'carshare'">
        <place-carshare :place="placeFull" />
      </template>
      <template v-else-if="place.isEkispertPlace">
        <place-ekispert-place :place="place" />
      </template>
      <template v-else-if="place.isGooglePlace">
        <place-google-place :place="place" />
      </template>
      <template v-else>
        <place-poi :place="placeFull">
          <slot></slot>
        </place-poi>
      </template>
    </template>
  </div>
</template>

<script>
import PlacePoi from './PlacePoi'
import PlaceCycle from './PlaceCycle'
import PlaceTolocca from './PlaceTolocca'
import PlaceBusstop from './PlaceBusstop'
import PlaceCarshare from './PlaceCarshare'
import PlaceGooglePlace from './PlaceGooglePlace'
import PlaceEkispertPlace from './PlaceEkispertPlace'
import PlaceFullLoading from './PlaceFullLoading'

import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  props: {
    place: {
      type: Object,
      required: true
    }
  },
  components: {
    PlacePoi,
    PlaceCycle,
    PlaceTolocca,
    PlaceBusstop,
    PlaceCarshare,
    PlaceGooglePlace,
    PlaceEkispertPlace,
    PlaceFullLoading
  },
  data () {
    return {
      loading: false,
      imageIndex: 0
    }
  },
  created () {
    this.updateDetail(this.place)
  },
  methods: {
    updateDetail: function (newPlace) {
      if (!_.isEmpty(newPlace) && !newPlace.isGooglePlace && !newPlace.isEkispertPlace) {
        this.loading = true
        this.$store.dispatch('places/fetchPlace', newPlace.id)
          .finally(() => {
            this.loading = false
          })
      }
    },
    getGenreType: function (id) {
      if (id) {
        const genre = this.$store.getters['genres/getGenreFromId'](id)
        if (genre) {
          return genre.type
        }
      }
    },
    onRingoPass: function (url) {
      this.$emit('onRingoPass', url)
    },
    prevImage: function () {
      this.imageIndex--
    },
    nextImage: function () {
      this.imageIndex++
    }
  },
  computed: {
    ...mapGetters({
      placeFull: 'places/getPlaceFull'
    }),
    genreId: function () {
      return this.place.genreIds && this.place.genreIds[0]
    }
  },
  watch: {
    place: function (newPlace) {
      this.updateDetail(newPlace)
    }
  }
}
</script>
